module.exports = __webpack_public_path__ + "img/quest_visualization_medal.90be1960.svg";